<!--Newsletter Start-->
<section class="stay-uptodate">
  <div class="container" *ngIf="loginType=='B2C'">
    <div class="heading">
      <div class="img"></div>
      <div class="text">
        <h2>Stay up <span>to Date</span></h2>
        <p>Scbscribe now and receive the latest travel news.</p>
      </div>
    </div>
    <form class="form">
      <div class="block">
        <div class="input-field outline">
          <input type="email" class="form-control" id="name" required placeholder="Your Name" name="name"
            [(ngModel)]="name">
        </div>
      </div>
      <div class="block">
        <div class="input-field outline">
          <input type="email" class="form-control" id="email" required placeholder="Email ID" name="email"
            [(ngModel)]="email">
        </div>
      </div>
      <a href="javascript:void(0)" (click)="subscribe()">subscribe</a>
    </form>
  </div>
</section>
<!--Newsletter End-->

<!--Download Mobile App start-->
<section class="downloadmobile-app">
  <div class="container" *ngIf="loginType=='B2C'">
    <h2>Download<span>Our Mobile App</span> </h2>
    <div class="center-block">
      <div class="imgbloack"> <a href="https://play.google.com/store/apps/details?id=com.akbartravel.AkbarTravels"
          target="_blank" class="googleplay"></a> <a href="https://itunes.apple.com/in/app/facebook/id955378983?mt=8"
          target="_blank" class="appstore"></a> </div>
      <h3>Get Download link on your Mobile</h3>
      <form>
        <div class="form">
          <div class="block">
            <div class="form-group">
              <input type="email" class="form-control" id="mobile" required placeholder="Enter Your Mobile Number"
                name="mobile" [(ngModel)]="mobile">
            </div>
          </div>
          <a href="javascript:void(0)" (click)="sendLinkToMobile()">Send Link to my Mobile</a>
        </div>
      </form>
    </div>
    <div class="qrcode-block">
      <div class="qrcode"></div>
      <p>Scan the QR Code to download the Akbartravels Mobile App</p>
    </div>
  </div>
</section>
<!--Download Mobile App End-->

<!-- Footer Start -->
<footer>
  <section class="topfooter">
    <div class="container" *ngIf="loginType=='B2C'">
      <div id="horizontalTab" class="resp-htabs">
        <ul class="resp-tabs-list">
          <li> Why akbartravels.com?</li>
          <li>Company Information</li>
          <li> Akbar On Mobile</li>
        </ul>
        <div class="resp-tabs-container">
          <div>
            <h3>Why akbartravels.com?</h3>
            <p>Our competitive rates and exclusive offers are what gives us a top notch over our
              competitors. We
              promise 'Unbeatable' services both in pricing and quality. For instance: Every Wednesday,
              travelers
              can save big with our ZERO Convenience fee on flight bookings. </p>
            <p> Also, we get it - travel’s a big decision. It’s not every day that you fly across the world
              to wander the souks of Dubai or enjoy a dreamy sunrise in Paris. But for us, it’s been our
              every day job for the past four decades. Let’s just say we know what travelers really want. We give
              you the pros and cons for all the different travel products and allow you to decide what works best
              for you and your family. While many travel companies claim to have experts, we believe few, match
              our own specialists for genuine- firsthand knowledge. We combine first-hand knowledge with
              exceptional special offers, and we take care of every detail to create a holiday as unique as you are.
              You will no more need to worry about coordinating flight bookings, hotel reservations, visa stamps or
              tours as all your needs are taken care of under one roof; the Akbar Travels roof. More than 85% of
              clients come back to us for future trips. </p>
            <p> When you choose Akbar Travels, your trip is in safe hands. Whilst you are abroad our team is
              available 24 hours a day, 365 days a year should you need assistance. We do absolutely
              everything for you, all you need to do is turn up at the airport with your bags and go! </p>
          </div>
          <div>
            <h3>Company Information</h3>
            <p>Akbartravels.com is a leading global online travel portal providing a diverse range of
              world-class,
              hassle-free travel services online. Our services include domestic and international flight
              booking,
              tailor-made and inclusive holidays, hotel reservations, visa services, cruises, car rentals,
              train
              tickets, worldwide attraction tickets, sightseeings, foreign exchange, travel insurance and
              much
              more. Our online platform allows users to search and book discounted flight tickets, holiday
              packages, visas and other services online from the comfort of their homes, office or
              smartphone
              effortlessly. With offices in India, UK, US, Middle East, Europe and Malaysia, we have more
              than
              150
              branches worldwide that extends the company’s reach to almost all major travel destinations
              of
              the
              world.</p>
          </div>
          <div>
            <h3>Akbar On Mobile</h3>
            <p>Join us on mobile through our top-rated free App, where you can book, check updates and keep
              all
              your
              travel plans, purchases & activities in one place. </p>
            <p>Get Instant Access to our App Exclusive Features:</p>
            <ul class="bullet">
              <li>Book via the App </li>
              <li>Manage your booking </li>
              <li>Access flight tickets, vouchers & all travel Information at your fingertips </li>
              <li>Easy to use </li>
              <li>Be the first one to learn about upcoming travel deals and offers </li>
              <li>Keep in touch with us anytime, anywhere</li>
            </ul>
            <p>Download the AkbarTravels App & wherever you’re going, take us with you.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="middle-footer">
    <div class="container" *ngIf="loginType=='B2C'">
      <div class="block">
        <h2>More Links</h2>
        <p>
          <a href="https://blog.akbartravels.com/" target="_blank">Blog</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/customersupport" target="_blank">Branches</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/bus-ticket-booking" target="_blank">Bus Tickets</a>
          <span class="slash"></span>

          <a href="https://www.akbartravels.com/utility/traveladvisory" target="_blank">Travel Advisory</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic" target="_blank">Domestic Flights </a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international" target="_blank">International
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/airlines/low-cost-airlines " target="_blank">Low Cost
            Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/airlines/cheap-flight-booking " target="_blank">Cheap Flight
            Booking</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/sectors/cheap-air-tickets " target="_blank">Cheap Air
            Tickets</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/flights-schedule" target="_blank">Flight
            Schedule</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/utility/aboutus" target="_blank">About
            Us</a>
          <span class="slash"></span>
          <a href="https://www.blueribbonbags.com/MishandledBaggageReports " target="_blank">Mishandled Baggage
            Report</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/partner-with-akbartravels " target="_blank">Partner With
            Us</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/faq " target="_blank">FAQs</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/utility/privacypolicy" target="_blank">Legal</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/careers " target="_blank">Careers</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/utility/retrievebooking " target="_blank">Retrieve Booking</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/newsupdates" target="_blank">News &
            Events</a>
          <span class="slash"></span>
          <a href="https://agents.akbartravelsonline.com/myaccount/login " target="_blank">Partner
            Login</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/agents/irctc" target="_blank">IRCTC
            Agent</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/Mobileapp/Index " target="_blank">Download our
            Mobile App</a>
        </p>
        <h2>Visa</h2>
        <p>
          <a href="https://www.akbartravels.com/visa/dubai-visa" target="_blank">Dubai
            Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/singapore-visa" target="_blank">Singapore Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/malaysia-visa" target="_blank">Malaysia Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/thailand-visa" target="_blank">Thailand Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/srilanka-visa" target="_blank">Sri
            Lanka Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/schengen-visa" target="_blank">Schengen Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/usa-visa" target="_blank">US
            Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/uk-visa" target="_blank">UK
            Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/china-visa" target="_blank">China
            Visa</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/visa/australia-visa" target="_blank">Australia Visa</a>
        </p>
        <h2>Domestic Tour Packages</h2>
        <p>
          <a href="https://www.akbartravels.com/holidays/india-tour-packages/jammu-and-kashmir-tour-packages"
            target="_blank">Kashmir Holiday Packages</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/india-tour-packages/leh-ladakh-tour-packages"
            target="_blank">Leh Ladakh Packages</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/india-tour-packages/goa-tour-packages" target="_blank">Goa
            Holidays</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/india-tour-packages/andaman-and-nicobar-tour-packages"
            target="_blank">Andaman Holidays</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/india-tour-packages/kerala-tour-packages"
            target="_blank">Kerala Tour Packages</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/india-tour-packages/himachal-pradesh-tour-packages"
            target="_blank">Himachal packages</a>
        </p>
        <h2>International tour packages</h2>
        <p>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/dubai-tour-packages"
            target="_blank">Dubai tour packages</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/malaysia-tour-packages"
            target="_blank">Malaysia tour package</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/singapore-tour-packages"
            target="_blank">Singapore tour package</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/thailand-tour-packages"
            target="_blank">Thailand tour packages</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/bali-tour-packages"
            target="_blank">Bali packages</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/sri-lanka-tour-packages"
            target="_blank">Srilanka tour package</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/europe-tour-packages"
            target="_blank">Europe tour packages</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/mauritius-tour-packages"
            target="_blank">Mauritius packages</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/holidays/international-tour-packages/maldives-tour-packages"
            target="_blank">Maldives packages</a>
        </p>
        <h2>Cruise Lines</h2>
        <p>
          <a href="https://www.akbartravels.com/cruises/cordelia-cruises"
            target="_blank">Cordelia Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/angriya-cruises"
            target="_blank">Angriya Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/carnival-cruise-line"
            target="_blank">Carnival Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/celebrity-cruises"
            target="_blank">Celebrity Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/costa-cruises"
            target="_blank">Costa Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/cunard-line"
            target="_blank">Cunard Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/Disney-cruise-line"
            target="_blank">Disney Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/dream-cruises"
            target="_blank">Dream Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/holland-america-line"
            target="_blank">Holland America Cruise</a>
            <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/msc-cruises"
            target="_blank">MSC Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/norwegian-cruise-line"
            target="_blank">Norwegian Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/princess-cruises"
            target="_blank">Princess Cruise</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/cruises/royal-caribbean-international"
            target="_blank">Royal Caribbean Cruise</a>
        </p>
      </div>
      <div class="block" fxFlex="50">
        <h2>International Flight</h2>
        <p>
          <a href="https://www.akbartravels.com/international/delhi-dubai-flights " target="_blank">Delhi Dubai
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/delhi-bangkok-flights " target="_blank">Delhi Bangkok
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/delhi-toronto-flights " target="_blank">Delhi Toronto
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/mumbai-dubai-flights " target="_blank">Mumbai Dubai
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/delhi-singapore-flights " target="_blank">Delhi Singapore
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/delhi-london-flights " target="_blank">Delhi London
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/delhi-kathmandu-flights " target="_blank">Delhi Kathmandu
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/mumbai-london-flights " target="_blank">Mumbai London
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/chennai-singapore-flights " target="_blank">Chennai
            Singapore Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/mumbai-singapore-flights " target="_blank">Mumbai
            Singapore Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/delhi-newyork-flights " target="_blank">Delhi Newyork
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international/kolkata-bangkok-flights " target="_blank">Kolkata Bangkok
            Flights</a>
        </p>
        <h2>Domestic Flight</h2>
        <p>
          <a href="https://www.akbartravels.com/domestic/pune-bangalore-flights " target="_blank">Pune Bangalore
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/chennai-delhi-flights " target="_blank">Chennai Delhi
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/bangalore-chennai-flights " target="_blank">Bangalore Chennai
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/mumbai-delhi-flights " target="_blank">Mumbai Delhi Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/bangalore-hyderabad-flights " target="_blank">Bangalore
            Hyderabad Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/ahmedabad-goa-flights " target="_blank">Ahmedabad Goa
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/mumbai-kolkata-flights " target="_blank">Mumbai Kolkata
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/hyderabad-delhi-flights " target="_blank">Hyderabad Delhi
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/bangalore-goa-flights " target="_blank">Bangalore Goa
            Flights</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/domestic/mumbai-goa-flights " target="_blank">Mumbai Goa Flights</a>
        </p>
        <h2>International Airlines</h2>
        <p>
          <a href="https://www.akbartravels.com/international-airlines/emirates " target="_blank">Emirates Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international-airlines/oman-air " target="_blank">Oman Air Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/airlines/air-india-express " target="_blank">Air India Express
            Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international-airlines/tiger-airways " target="_blank">Tiger Airways</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international-airlines/kuwait-airways " target="_blank">Kuwait
            Airways</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international-airlines/air-arabia " target="_blank">Air Arabia
            Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international-airlines/etihad " target="_blank">Etihad Airways</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international-airlines/srilankan-airlines " target="_blank">Srilankan
            Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/international-airlines/air-asia " target="_blank">Air Asia India
            Airlines</a>
        </p>
        <h2>Domestic Airlines</h2>
        <p>
          <a href="https://www.akbartravels.com/airlines/indigo" target="_blank">Indigo Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/airlines/spicejet " target="_blank">Spicejet Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/airlines/air-india" target="_blank">Air India Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/airlines/goair" target="_blank">Go Air Airlines</a>
          <span class="slash"></span>
          <a href="https://www.akbartravels.com/airlines/air-costa" target="_blank">Air Costa Airlines</a>
        </p>
      </div>
    </div>
  </section>



  <!------------------------------
    B2B FOOTER START
    -------------------------------->

  <section class="b2b-middle-footer common-padding" *ngIf="loginType=='B2B'">
    <div class="container">
      <div class="hotel-support">
        <h2>Cruise Support</h2>
        <ul>
          <li>
            <h3>International / Domestic Cruise</h3>
            <h4>+918652638054</h4>
            <h4>Cruises@akbartravelsonline.com</h4>
          </li>
          <!-- <li>
      <h3>Packages</h3>
      <h4>022 40743434</h4>
      <h4>fit@akbartravelsonline.com</h4>
      </li>
      <li>
      <h3>Europamundo Fixed Departure</h3>
      <h4>022 40743434</h4>
      <h4>onlineproducts@akbartravelsonline.com</h4>
      </li> -->
        </ul>
      </div>
      <div class="block">
        <p>
          <a rel="noopener" href="#" target="_blank">Home </a><span class="slash"></span>
          <span class="slash"></span>
          <a rel="noopener" href="https://agents.akbartravelsonline.com/MyAccount/BankAccounts" target="_blank">Bank
            Accounts</a><span class="slash"></span>
          <a rel="noopener" href="https://agents.akbartravelsonline.com/MyAccount/CustomerGST" target="_blank">GST
            Baggage Report </a><span class="slash"></span>

          <a rel="noopener" href="https://agents.akbartravelsonline.com/MyAccount/TermsAndConditions"
            target="_blank">Terms & Conditions
          </a><span class="slash"></span>
          <a rel="noopener" href="https://agents.akbartravelsonline.com/MyAccount/Disclaimer" target="_blank">Disclaimer
          </a>
          <span class="slash"></span>
          <a rel="noopener" href="https://agents.akbartravelsonline.com/MyAccount/PrivacyPolicy" target="_blank">Privacy
            Policy</a>
          <span class="slash"></span>
          <a rel="noopener" href="https://agents.akbartravelsonline.com/MyAccount/HelpAndFaqs" target="_blank">Help</a>

        </p>

      </div>
    </div>
  </section>


  <!------------------------------
          B2B FOOTER END
          -------------------------------->




  <section class="bottom-footer">
    <div class="container" *ngIf="loginType=='B2C'">
      <div class="firstrow">
        <div class="socialmedia">
          <h2>Follow us</h2>
          <ul>
            <li> <a href="#" target="_blank"> <span class="ak-facebook"></span> </a> </li>
            <li> <a href="#" target="_blank"> <span class="ak-twitter "></span> </a> </li>
            <li> <a href="#" target="_blank"> <span class="ak-instagram"></span> </a> </li>
          </ul>
        </div>
        <div class="rightsection">
          <div class="squareouter">
            <div class="row-one">
              <div class="imgouter">
                <h6>We Accept</h6>
              </div>
              <div class="imgouter">
                <div class="visacard img"></div>
              </div>
              <div class="imgouter">
                <div class="mastercard img"></div>
              </div>
              <div class="imgouter" f>
                <div class="dinersclub img"></div>
              </div>
              <div class="imgouter">
                <div class="amex img"></div>
              </div>
              <div class="imgouter">
                <div class="rupay img"></div>
              </div>
            </div>
            <div class="row-one">
              <div class="imgouter">
                <h6>Member of</h6>
              </div>
              <div class="imgouter">
                <div class="incradibleindia img"></div>
              </div>
              <div class="imgouter">
                <div class="iata img"></div>
              </div>
              <div class="imgouter">
                <div class="tafi img"></div>
              </div>
              <div class="imgouter">
                <div class="maharashtrature img"></div>
              </div>
            </div>
          </div>
          <div class="certified-block">
            <h3>Certified By</h3>
            <a href="https://sealserver.trustkeeper.net/compliance/cert.php?code=x4ix8flmFVRIQRKlPlfZ1Nc3X2IC2k"
              target="_blank">
              <div class="trustwave img"></div>
            </a>
          </div>
          <div class="powered-block">
            <h3>Powered By</h3>
            <a r href="http://www.benzyinfotech.com/" target="_blank">
              <div class="benzy img"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <p>Copyright © 2020 <a target="_blank" href="https://www.akbartravels.com/">www.akbartravels.com</a> All Rights
      Reserved. </p>
  </section>
</footer>
<!-- Footer end -->